export default __webpack_public_path__ + "static/media/hm-ttg-img.6c1077be.webp";